// featureIcons.ts
/**
 * Maps feature icon names to their corresponding UI icon components
 * used throughout dashboard navigation and widgets.
 */
import {
  BellRinging01,
  BookClosed,
  BookOpen01,
  Calendar,
  CalendarCheck01,
  CheckSquareBroken,
  CurrencyDollarCircle,
  Eye,
  File02,
  File06,
  FolderCode,
  GraduationHat02,
  Lightbulb05,
  PieChart03,
  Stars03,
  Target04,
  TrendUp01,
  BarChart10,
  LineChartUp03,
  Backpack,
} from "@untitledui/icons";

export const FEATURE_ICONS = {
  Stars03,
  TrendUp01,
  CheckSquareBroken,
  BellRinging01,
  BookOpen01,
  CalendarCheck01,
  Target04,
  Calendar,
  BookClosed,
  Backpack,
  GraduationHat02,
  PieChart03,
  FolderCode,
  Eye,
  File06,
  File02,
  CurrencyDollarCircle,
  Lightbulb05,
  BarChart10,
  LineChartUp03,
};